import { Injectable }      from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransactionCenterService {
  searchSubject = new BehaviorSubject<string | null>(null);

  searchChanges = this.searchSubject.asObservable();

  setSearch ( value : string ) : void {
    this.searchSubject.next(value || '');
  }
}
